import { FetchFn } from '@wix/thunderbolt-symbols'
import { MetricsReporter } from '@wix/thunderbolt-becky-types'

export type BuildSvgUrl = (mediaRootUrl: string, svgId: string) => string

export const fetchShapes = async (
	shapeIds: Array<string>,
	fetchFn: FetchFn,
	mediaRootUrl: string,
	buildSvgUrl: BuildSvgUrl,
	metricsReporter: MetricsReporter
): Promise<Record<string, string>> => {
	const shapesArray = await Promise.all(
		(shapeIds ? shapeIds : []).map(async (shapeId: string) => {
			const shapeUrl = buildSvgUrl(mediaRootUrl, shapeId)
			const shapeContent = await fetchFn(shapeUrl)
				.then((resp: Response) => resp.text())
				.catch((e) => {
					metricsReporter.reportError(e)
					return `<svg data-svg-id="fallback-${shapeId}" />`
				})
			return { id: shapeId, content: shapeContent }
		})
	)

	return shapesArray.reduce((acc: Record<string, string>, { id, content }: { id: string; content: string }) => {
		return { ...acc, [id]: content }
	}, {} as Record<string, string>)
}
